/* global System */
// register component(s) with react habitat

export default { Mietpark: () => System.import('./index') }
